import { CstIndiIncomeEntityIdDto } from './cst-indi_income_entity_id-dto';
import { AddressDTO } from './address-dto';

export class IncomeDTO {

  grossSalary: number;
  annualIncome: number;
  itrIncome: number;
  netSalary: number;
  organisationName: string;
  abbToEmi: string;
  aproxAvgBankBal: number;
  salCredBankFlag: boolean = true;
  longevityId: number;
  cstIndiIncomeEntityId: CstIndiIncomeEntityIdDto;
  occupationTypcode: string;
  designation: string;
  quotationId: string;
  quotStatusId: string = " ";
  applicantTypeTypcode: string;
  cstAddrDto: AddressDTO=new AddressDTO();;


  constructor() {
    //  this.quotStatusId = 3;
    this.cstIndiIncomeEntityId = new CstIndiIncomeEntityIdDto();
       this.cstAddrDto.addressTypcode="OFFICE";
  }
  
}